export const environment = {
  apiBaseUrl: 'https://api-reach.home-connect.co.za',
  apiHomeConnectUrl: 'https://portal.home-connect.co.za/Webapi/',
  apiHomeConnectClientUrl: 'https://portal.home-connect.co.za/#/checkcoverage',
  appBaseUrl: 'https://reach.home-connect.co.za/register',
  zoomPortalUrl: 'https://sa.zoomflex.co.za/checkout',
  recaptcha: {
    siteKey: '6Le02HQqAAAAAAiyW3wPgMSq0eU9aNZwAV2zWXjv',
  },
  tokenEndPoint: '/api/token',
  production: true,
  environment: 'PROD',
  showEnvironment: false,
  VumatelPromoProductId: [25, 26],//once-off-25, Recurring-26
  VumatelNonPromoProductId: [1, 2],//once-off-1, Recurring-2
  VumatelPromoDate: new Date('2026-10-31T23:59:59Z'),//Promotion end date
  VumatelProm1010ProductId: [27, 28],//once-off-27, Recurring-28
  Vumatel1010NonPromoProductId: [10, 11],//once-off-10, Recurring-11
  Vumatel1010PromoDate: new Date('2026-08-31T23:59:59Z'),//Promotion end date
  Microsoft: {
    clientId: '6b33efd8-3ee4-498a-b093-85d733c21548',
    authority: 'https://login.microsoftonline.com/633acf82-28bc-41ca-afa1-c740347908ad',
    redirectUri: 'https://reach.home-connect.co.za/login-callback',
  },
  ZoomHybridProductId: 29,
};
